export default {"src":"/_next/static/media/discord-logo.b990b866.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};